<template>
  <li class="flex items-stretch w-full py-5 border-b border-zinc-600">
    <div class="w-1/5">
      <img :src="$ImageUrl(active_option_image)" />
    </div>
    <div class="flex flex-col items-start flex-1 pl-5">
      <p class="mb-2 text-sm text-white">
        {{ shop_cart_item.product_data.Title }}
      </p>
      <div class="flex-1">
        <p
          v-if="active_stock.ColorTitle != '無'"
          class="mb-1 text-xs font-light text-zinc-300"
        >
          {{ shop_cart_item.product_data.Option1 }}：<span
            class="text-current"
            >{{ active_stock.ColorTitle }}</span
          >
        </p>
        <p
          v-if="active_stock.SizeTitle != '無'"
          class="text-xs font-light text-zinc-300"
        >
          {{ shop_cart_item.product_data.Option2 }}：<span
            class="text-current"
            >{{ active_stock.SizeTitle }}</span
          >
        </p>
      </div>
      <div class="inline-flex items-center mt-3 border border-zinc-600">
        <button
          @click="Remove(shop_cart_index, 1)"
          class="flex items-center justify-center w-8 transition-all duration-300 h-7 hover:md:opacity-50"
        >
          <i class="text-xs icon-minus"></i>
        </button>
        <input
          type="text"
          :value="shop_cart_item.amount"
          class="w-10 text-center bg-transparent work_sans"
        />

        <button
          @click="Add(shop_cart_index)"
          class="flex items-center justify-center w-8 transition-all duration-300 h-7 hover:md:opacity-50"
        >
          <i class="text-xs icon-plus"></i>
        </button>
      </div>
    </div>
    <div class="flex flex-col items-end flex-shrink-0 pl-3 text-right">
      <p class="flex-1 mb-1 text-base font-bold text-primary">
        ${{ $MoneyFormat(total_price) }}
      </p>
      <button
        @click="Remove(shop_cart_index, shop_cart_item.amount)"
        class="flex items-center justify-center w-8 h-8 transition-all duration-300 hover:md:bg-opacity-100 hover:md:text-white"
      >
        <i class="text-lg icon-bin text-zinc-500"></i>
      </button>
    </div>
  </li>
</template>

<script>
import { getLocalStorage } from "@/common/cookie";
import { GTM_RemoveShopCart } from "@/common/gtm_methods";
export default {
  name: "ShopCartProductCard",
  props: {
    shop_cart_item: {
      require: true,
      type: Object,
    },
    shop_cart_index: {
      require: true,
      type: Number,
    },
    is_member: {
      require: true,
      type: Boolean,
    },
  },
  methods: {
    Add(index) {
      // GTM_AddShopCart(this.shopcart[index], 1);
      const shop_cart_item = {
        product: this.shop_cart[index].product_data,
        options: this.shop_cart[index].active_option,
        amount: 1,
      };
      if (getLocalStorage("account_token")) {
        this.$store.dispatch("shopcart_module/AddShopCart", shop_cart_item);
      } else {
        this.$store.commit("shopcart_module/AddShopCart", shop_cart_item);
      }
    },
    Remove(index, count, type = "normal_product") {
      if (type == "normal_product") {
        GTM_RemoveShopCart(this.shop_cart[index], count);
      }
      if (getLocalStorage("account_token")) {
        this.$store.dispatch("shopcart_module/RemoveShopCart", {
          index: index,
          amount: count,
        });
      } else {
        this.$store.commit("shopcart_module/RemoveShopCart", {
          index: index,
          amount: count,
        });
      }
    },
  },
  computed: {
    active_stock() {
      return this.shop_cart_item.product_data.Stock.filter((item) => {
        return (
          item.ColorID == this.shop_cart_item.active_option[0] &&
          item.SizeID == this.shop_cart_item.active_option[1]
        );
      })[0];
    },
    active_option_image() {
      const images = this.shop_cart_item.product_data.Picture;
      const full_match_image = images.filter(
        (item) =>
          item.ColorID == this.shop_cart_item.active_option[0] &&
          item.SizeID == this.shop_cart_item.active_option[1]
      );
      const end_match_image = images.filter(
        (item) => item.SizeID == this.shop_cart_item.active_option[1]
      );
      const start_match_image = images.filter(
        (item) => item.ColorID == this.shop_cart_item.active_option[0]
      );

      return full_match_image.length > 0
        ? full_match_image[0].Image
        : end_match_image.length > 0
        ? end_match_image[0].Image
        : start_match_image.length > 0
        ? start_match_image[0].Image
        : this.shop_cart_item.product_data.Image1;
    },
    total_price() {
      const sell_price =
        parseInt(this.active_stock.SellPrice) *
        parseInt(this.shop_cart_item.amount);
      const member_sell_price =
        parseInt(this.active_stock.MemberSellPrice) *
        parseInt(this.shop_cart_item.amount);
      return this.is_member ? member_sell_price : sell_price;
    },
    shop_cart() {
      return this.$store.state.shopcart_module.shopcart;
    },
  },
};
</script>
